import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    mounted() {
        // Overwriting base render method with actual data.
        this.renderChart({
            labels: [
                'Januar',
                'Februar',
                'März',
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember',
            ],
            datasets: [
                {
                    label: this.__('Umsatz'),
                    backgroundColor: '#f87979',
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                }
            ]
        }
        )
    }
}